const reliability = {
  create: "ERSTELLEN SIE EINE NEUE ÜBERPRÜFUNG DER ZUVERLÄSSIGKEIT",

  profile: "PRÜFPROFIL FÜR BETRIEBSSICHERHEIT",
  search: "Suche",
  equipmentTag: "Ausrüstungs-Tag",
  equipmentType: "Ausstattungsart",
  company: "Unternehmen",
  repairDate: "Zuverlässigkeitsprüfdatum",
  createdBy: "Erstellt von",
  customer: "Kunde",
  Reliabilty: "Verlässlichkeit",
  submit: "EINREICHEN",
  list: "Liste der Betriebssicherheitinsprüfung",
  delete: "LÖSCHEN",
  status: "Status"
};
export default reliability;
